(function () {
  const MOBILE_BREAKPOINT = 768;

  class DualStickyScroll {
    constructor(container) {
      this.container = container;
      this.columns = [container.children[0], container.children[1]];
      this.lastScrollY = window.scrollY;
      this.tops = [0, 0];
      this.active = false;
      this._onScroll = this.update.bind(this);
      this._onResize = this.handleResize.bind(this);
    }

    getHeaderOffset() {
      const header = document.getElementById("header");
      if (!header) return 10;
      const bottom = Math.round(header.getBoundingClientRect().bottom);
      return bottom > 0 ? bottom : 10;
    }

    init() {
      window.addEventListener("scroll", this._onScroll, { passive: true });
      window.addEventListener("resize", this._onResize);
      const header = document.getElementById("header");
      if (header) {
        this._onHeader = () => {
          this._followUntil = Date.now() + 280;
          this._followHeader();
        };
        header.addEventListener("transitionrun", this._onHeader);
        header.addEventListener("transitionstart", this._onHeader);
        header.addEventListener("transitionend", this._onHeader);
      }
      this.handleResize();
    }

    _followHeader() {
      this.update();
      if (Date.now() < this._followUntil) {
        this._headerRaf = window.requestAnimationFrame(() => {
          this._headerRaf = 0;
          this._followHeader();
        });
      }
    }

    activate() {
      if (this.active) return;
      this.active = true;
      this.columns.forEach((col) => {
        col.style.position = "sticky";
        col.style.alignSelf = "start";
      });
      this.lastScrollY = window.scrollY;
      this.tops = [0, 0];
      this.update();
    }

    deactivate() {
      if (!this.active) return;
      this.active = false;
      this.columns.forEach((col) => {
        col.style.position = "";
        col.style.top = "";
        col.style.alignSelf = "";
      });
    }

    handleResize() {
      if (window.innerWidth > MOBILE_BREAKPOINT) {
        this.activate();
      } else {
        this.deactivate();
      }
    }

    update() {
      if (!this.active) return;

      const scrollY = window.scrollY;
      const delta = scrollY - this.lastScrollY;
      const vh = window.innerHeight;
      const headerOffset = this.getHeaderOffset();

      this.columns.forEach((col, i) => {
        const h = col.offsetHeight;

        if (h <= vh - headerOffset) {
          col.style.top = `${headerOffset}px`;
          this.tops[i] = headerOffset;
          return;
        }

        let newTop = this.tops[i] - delta;
        const minTop = vh - h;
        const maxTop = headerOffset;

        newTop = Math.max(minTop, Math.min(maxTop, newTop));

        this.tops[i] = newTop;
        col.style.top = `${newTop}px`;
      });

      this.lastScrollY = scrollY;
    }

    destroy() {
      window.removeEventListener("scroll", this._onScroll);
      window.removeEventListener("resize", this._onResize);
      const header = document.getElementById("header");
      if (header && this._onHeader) {
        header.removeEventListener("transitionrun", this._onHeader);
        header.removeEventListener("transitionstart", this._onHeader);
        header.removeEventListener("transitionend", this._onHeader);
      }
      this.deactivate();
    }
  }

  document.addEventListener("DOMContentLoaded", () => {
    document
      .querySelectorAll("[data-dual-sticky]")
      .forEach((grid) => {
        if (grid.children.length >= 2) {
          const instance = new DualStickyScroll(grid);
          instance.init();
        }
      });
  });
})();
